import { addOrUpdateSwarm, selectSwarmById } from '../../../../store/slices/swarmsInAction';

export const createSignalRHandlers = (dispatch, getState, handleUpdateSwarmCounter, mapSwarmToSwarmInActionRes) => ({
  handleEditSwarmEvent: (req, eventModel, swarmHasPendingBuyRequest) => {
    try {
      console.log("swarmAdmin2.0 [EditSwarmEvent] handler called");
      console.log("swarmAdmin2.0 [EditSwarmEvent] data:", { req, eventModel, swarmHasPendingBuyRequest });
      const updatedSwarm = mapSwarmToSwarmInActionRes(
        req,
        eventModel,
        swarmHasPendingBuyRequest
      );
      console.log("swarmAdmin2.0 [EditSwarmEvent] mapped swarm:", updatedSwarm);
      dispatch(addOrUpdateSwarm(updatedSwarm));
    } catch (error) {
      console.error('swarmAdmin2.0 [EditSwarmEvent] error:', error);
    }
  },

  handleNewBuyRequestEvent: (req) => {
    try {
      console.log("swarmAdmin2.0 [CreateSwarmBuyRequest] handler called");
      console.log("swarmAdmin2.0 [CreateSwarmBuyRequest] data:", req);
      handleUpdateSwarmCounter(req.swarmId, 'pending', req.quantity);
    } catch (error) {
      console.error('swarmAdmin2.0 [CreateSwarmBuyRequest] error:', error);
    }
  },

  handleAcceptedBuyRequestEvent: (req) => {
    try {
      console.log("swarmAdmin2.0 [AcceptedSwarmBuyRequest] handler called");
      console.log("swarmAdmin2.0 [AcceptedSwarmBuyRequest] data:", req);
  
      const state = getState();
      const swarm = selectSwarmById(req.swarmId)(state);
  
      if (swarm) {
        const currentPending = swarm.pending || 0;
        const currentAccepted = swarm.accepted || 0;
  
        // Decrease pending by 1, not going below 0
        const newPending = Math.max(0, currentPending - req.quantity);
        // Increase accepted by 1
        const newAccepted = currentAccepted + req.quantity;
  
        const updatedSwarm = {
          ...swarm,
          pending: newPending,
          accepted: newAccepted,
          // Update hasPendingBuyRequest based on new pending count
          hasPendingBuyRequest: newPending > 0
        };
  
        dispatch(addOrUpdateSwarm(updatedSwarm));
      }
    } catch (error) {
      console.error('swarmAdmin2.0 [AcceptedSwarmBuyRequest] error:', error);
      throw error;
    }
  },

  handleRejectedSwarmBuyRequestEvent: (req) => {
    try {
      console.log("swarmAdmin2.0 [RejectedSwarmBuyRequest] handler called");
  
      const state = getState();
      const swarm = selectSwarmById(req.swarmId)(state);
  
      if (swarm) {
        const currentPending = swarm.pending || 0;
        const newPending = Math.max(0, currentPending - req.quantity);
  
        const updatedSwarm = {
          ...swarm,
          pending: newPending,
          hasPendingBuyRequest: newPending > 0
        };
  
        dispatch(addOrUpdateSwarm(updatedSwarm));
      }
    } catch (error) {
      console.error('swarmAdmin2.0 [RejectedSwarmBuyRequest] error:', error);
      throw error;
    }
  },
  handleCanceledByBeeSwarmBuyRequestEvent: (req) => {
    try {
      console.log("swarmAdmin2.0 [CanceledByBeeSwarmBuyRequest] handler called");
      console.log("swarmAdmin2.0 [CanceledByBeeSwarmBuyRequest] data:", req);
      const state = getState();
      const swarm = selectSwarmById(req.swarmId)(state);

      const currentPending = swarm.pending || 0;
      const newPending = Math.max(0, currentPending - req.quantity);

      const updatedSwarm = {
        ...swarm,
        pending: newPending,
        hasPendingBuyRequest: newPending > 0
      };

      dispatch(addOrUpdateSwarm(updatedSwarm));
    } catch (error) {
      console.error('swarmAdmin2.0 [CanceledByBeeSwarmBuyRequest] error:', error);
      throw error;
    }
  },
  handleLostBuyRequestEvent: (req) => {
    try {
      console.log("swarmAdmin2.0 [LostSwarmBuyRequest] handler called");
      console.log("swarmAdmin2.0 [LostSwarmBuyRequest] data:", req);
      const state = getState();
      const swarm = selectSwarmById(req.swarmId)(state);

      const currentAccepted = swarm.accepted || 0;
      const newAccepted = Math.max(0, currentAccepted - req.quantity);

      const updatedSwarm = {
        ...swarm,
        accepted: newAccepted,
      };

      dispatch(addOrUpdateSwarm(updatedSwarm));
    } catch (error) {
      console.error('swarmAdmin2.0 [LostSwarmBuyRequest] error:', error);
    }
  },

  handleCompletedBuyRequestEvent: (req) => {
    try {
      console.log("swarmAdmin2.0 [CompletedSwarmBuyRequest] handler called");
      console.log("swarmAdmin2.0 [CompletedSwarmBuyRequest] data:", req);
      const state = getState();
      const swarm = selectSwarmById(req.swarmId)(state);

      const currentAccepted = swarm.accepted || 0;
      const newAccepted = Math.max(0, currentAccepted - req.quantity);

      const currentCompleted = swarm.completed || 0;
      const newCompleted = currentCompleted + req.quantity;

      const updatedSwarm = {
        ...swarm,
        accepted: newAccepted,
        completed: newCompleted,
      };
      console.log("swarmAdmin2.0 [CompletedSwarmBuyRequest] updatedSwarm:", updatedSwarm);

      dispatch(addOrUpdateSwarm(updatedSwarm));
    } catch (error) {
      console.error('swarmAdmin2.0 [CompletedSwarmBuyRequest] error:', error);
    }
  }
});